import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
import common from './modules/common'
import user_store from './modules/user';


export default new Vuex.Store({
    modules: {
        user    : user_store,
        common,
    },
})
